var render = function render(){var _vm=this,_c=_vm._self._c;return _c('email-change-commit',{attrs:{"emailToken":_vm.token},on:{"emailChanged":_vm.goto}})
}
var staticRenderFns = []

export { render, staticRenderFns }